// extracted by mini-css-extract-plugin
export default {"heading":"MainHeading_heading__pR6v2","back_button":"MainHeading_back_button__GWfFO"};